module.exports = __webpack_public_path__ + "img/stock6.d36ec59c.png";